const PromoBox = ({ children }) => (
  <div className="bg-light-grey promo-box">
    <div className="container">
      <div className="row content-box">
        <div className="col-sm-12 section">{children}</div>
      </div>
    </div>
  </div>
);

export default PromoBox;
